export const GET_PROGRAMS_REQUEST = 'GET_PROGRAMS_REQUEST';
export const GET_PROGRAMS_SUCCESS = 'GET_PROGRAMS_SUCCESS';
export const GET_PROGRAMS_ERROR = 'GET_PROGRAMS_ERROR';
export const LOAD_PROGRAMS_REQUEST = 'LOAD_PROGRAMS_REQUEST';
export const LOAD_PROGRAMS_SUCCESS = 'LOAD_PROGRAMS_SUCCESS';
export const LOAD_PROGRAMS_ERROR = 'LOAD_PROGRAMS_ERROR';
